import Slider from "./lib/slider";

export default class ImageSlider {
    constructor(element) {
        this.element = element;

        /* This changes the slide selector to make the component work in pimcore editmode */
        let slideSelector = ".image-slider__slide"
        if(this.element.classList.contains('editmode')){
            slideSelector = ".pimcore_area_entry"
        }

        this.slider = new Slider(element, slideSelector);

        if(element.querySelectorAll(".image-slider__slide").length <= 1) {
            let controls = this.element.querySelector(".control");
            controls.parentElement.removeChild(controls);
            return;
        }

        this.initializeControls();

        this.autoplay = element.getAttribute('data-autoplay') === 'true';
        this.autoplayInterval = element.getAttribute('data-autoplay-interval') || 5000;
        if (this.autoplay) {
            this.startAutoplay(this.autoplayInterval)
        }
    }

    initializeControls() {
        this.nextControl = this.element.querySelector(".control--right");

        this.nextControl.addEventListener("click", () => {
            this.slider.next();
            this.stopAutoplay();
            this.updateControls()
        });

        this.previousControl = this.element.querySelector(".control--left");

        this.previousControl.addEventListener("click", () => {
            this.slider.previous();
            this.stopAutoplay();
            this.updateControls();
        });

        /* Create indicator dots for slider controls */
        this.controlIndicator = this.element.querySelector('.control__indicator');
        for(let i = 0; i < this.element.querySelectorAll(".image-slider__slide").length; i++){
            let indicatorWrapper = document.createElement('div')
            indicatorWrapper.classList.add('control__indicator__wrapper')
            let indicatorDot = document.createElement('span')
            indicatorDot.classList.add('control__indicator__wrapper__dot')
            indicatorWrapper.appendChild(indicatorDot)
            this.controlIndicator.appendChild(indicatorWrapper)
        }
        this.controlIndicatorDots = this.element.querySelectorAll('.control__indicator__wrapper')
        for(let i = 0; i < this.controlIndicatorDots.length; i++){
            this.controlIndicatorDots[i].addEventListener('click', () => {
                this.slider.setIndex(i)
                this.updateControls()
            })
        }
        this.updateControls()
    }

    updateControls(){
        this.controlIndicatorDots.forEach(dot => {
            dot.classList.remove('active');
        })
        this.controlIndicatorDots[this.slider.activeIndex].classList.add('active')
    }

    startAutoplay(interval) {
        this.autoplayId = setInterval(() => {
            this.slider.next();
            this.updateControls();
        }, interval);
    }

    stopAutoplay() {
        if (!this.autoplayId) return;
        clearInterval(this.autoplayId);
    }
}
